import React from 'react'
import { Box } from '@mui/material'
import { Button } from '@pepsico-ds/ui'

function ErrorComponent() {
  const redirectToHome = () => {
    window.location.replace('/')
  }

  const refresh = () => {
    window.location.reload()
  }

  return (
    <Box>
      <Button className="mr-1" onClick={refresh}>
        Refresh
      </Button>
      <Button className="mr-1" type="primary" onClick={redirectToHome}>
        Back Home
      </Button>
    </Box>
  )
}

export default ErrorComponent
